import { render } from "./EditFrequence.vue?vue&type=template&id=18f4d128"
import script from "./EditFrequence.vue?vue&type=script&lang=js"
export * from "./EditFrequence.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__